import React, { useEffect } from 'react';
import { CheckIcon } from 'lucide-react';
const FORM_EMBED_SRC = 'https://api.viridiaanalytics.com/js/form_embed.js';
const callAgenda: string[] = ['We pull your response-time gaps across every lead source you pay for', 'You hear the live demo on your own script, in your own tone', 'You get the missed-lead math for your team whether you sign or not'];
export function Booking() {
  useEffect(() => {
    if (document.querySelector(`script[src="${FORM_EMBED_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = FORM_EMBED_SRC;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <section id="book" aria-labelledby="book-title" className="scroll-mt-20 border-b border-white/5 bg-ink-900" data-id="element-19" data-mp="1o9umnxtjkny9">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-24" data-id="element-20" data-mp="1abmt7zvps4ru">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-21" data-mp="1f8wfj6nt40bg">
          Missed-Lead Audit
        </p>
        <h1 id="book-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-22" data-mp="1qvh0dhvdj8bt">
          Book your 15-minute Missed-Lead Audit.
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-23" data-mp="1vwdd8kxpe4td">
          We will pull your response-time gaps and show you the live demo on your own
          script. Worst case, you learn your team is airtight.
        </p>

        <div className="mt-8" data-id="element-24" data-mp="1390u6kqr4f4t">
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-25" data-mp="135v0stb3ar3a">
            What happens on the call
          </h2>
          <ul className="mt-4 space-y-3" data-id="element-26" data-mp="1d4u9gbvuumqa">
            {callAgenda.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-white/70" data-id="element-27" data-mp="pfj5ymn4ee8g">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-28" data-mp="kf3vc2u83ku6" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-10 overflow-hidden rounded-xl border border-white/10 bg-white" data-id="element-29" data-mp="2u9iu6rc45oo3">
          <iframe src="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" style={{
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          minHeight: '700px'
        }} scrolling="no" id="viridia-booking" title="Book your 15-minute Missed-Lead Audit" loading="eager" data-id="element-30" data-mp="2yamd5mpgk0tj" />
        </div>
      </div>
    </section>;
}